import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { icons } from '@assets/icons';

export const StyledReportWrap = styled.div`
  margin-top: 15px;
`;

export const StyledReportArea = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  margin-bottom: 10px;
  padding: 20px 40px;
  & > strong {
    position: relative;
    display: block;
    width: 203px;
    font-size: 16px;
    line-height: 23px;
    color: #333;
  }
`;

export const StyledReportFlex = styled.div`
  margin-left: 9px;
  margin-right: 23px;
  border-left: 1px solid #e0e0e0;

  position: relative;
  padding-left: 32px;
  color: #000;

  & .flex-box {
    display: flex;
    align-items: center;
    margin-bottom: 11px;

    & > .color-map-title {
      width: 150px;
    }

    & span {
      &.suffix {
        margin-left: 8px;
      }
    }
  }
`;

export const FlexBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;

  span {
    &.title {
      width: 75px;
    }

    &.l-title {
      margin-right: 28px;
      font-size: 14px;
    }

    &.suffix {
      margin-left: 5px;
    }
  }
  & .l-input {
    width: 48px;
    & input {
      height: 32px !important;
    }
  }

  & + & {
    margin-left: 45px;
  }

  & .tmax-input-title {
    margin: 0 10px;
  }
  & .tmax-input > div {
    margin-top: 4px;
  }

  & .delete-text {
    font-weight: 400;
    font-size: 14px;
    color: #667080;
  }
  & .delete-btn {
    width: 16px;
    height: 16px;
    margin: 2px 30px 0 8px;
    background-image: url(${icons.emptyDeleteIcon});

    &:hover {
      background-image: url(${icons.emptyDeleteIconHover});
    }

    &:active {
      background-image: url(${icons.emptyDeleteIconActive});
    }
  }

  & .vertical-bar {
    width: 1px;
    height: 6px;
    margin-right: 30px;
    background-color: #000;
  }

  & .delete-text + .vertical-bar {
    margin-left: 30px;
  }
  & .threshold-add-btn {
    display: inline-block;
    width: 30px;
    height: 15px;
    margin-top: 5px;
    margin-left: 10px;
    border: 1px solid #00bf00;
    border-radius: 32px;
    font-size: 10px;
    color: #00bf00;
    text-align: center;
    background-color: #fff;

    &:hover {
      background-color: #effdda;
    }

    &:active {
      color: #fff;
      background-color: #00bf00;
    }
    &:disabled {
      border: 1px solid #b8b8b8;
      border-radius: 32px;
      font-size: 10px;
      color: #b8b8b8;
      text-align: center;
      background-color: #eee;
      cursor: default;
    }
  }
`;

export const StyledOnOffFlex = styled.div`
  display: flex;
  align-items: center;

  .switch-wrap {
    margin: 0 10px;
  }

  span {
    font-size: 14px;
    color: #667080;
  }
`;

export const StyledDuplicateDescription = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: #bbb;
`;
